<template>
  <div :class="className">
    <div v-if="hasBackground" :class="backgroundClass" :style="'background-image: url(\'' + this.backgroundImage + '\')'"></div>
    <div v-if="hasBackground" :class="blurClass" :style="'background-image: url(\'' + this.backgroundImage + '\')'"></div>
    <div :class="'container ' + theme" style="position: relative; background-color: transparent !important">
      <div :class="logoClass">
        <div class="col-xs-12" style="text-align: center"><img v-if="profileImage" :src="profileImage" :style="'max-width: 100%; ' + (basketEmpty ? '' : 'max-height: 80px')" /><h3 v-else>{{ _('Welcome!') }}</h3></div>
      </div>
      <div class="panel panel-default" style="border-radius: 20px; opacity: 0.9" v-if="!basketEmpty">
        <div class="panel-body">
          <div class="row">
            <div class="cart-column-wrap" v-if="numBaskets">
              <div class="col-md-12 js-cart-col" :data-shop="basketShopId" v-for="(items, basketShopId) in myBasketItems">
                <template v-if="items.length">
                  <cart-item :theme="theme" :readonly="true" :settings="shopSettings(basketShopId)" :shopId="basketShopId" :baseDomain="baseDomain" :locale="locale" :currItem="item" v-for="item in items.filter(i => !i.discount_id && !i.valuecard_id)" :key="item.id" leftcolwidth="0" rightcolwidth="12" context="page"></cart-item>
                  <div class="js-cart-merchant row" v-if="numBaskets > 1">
                    <div class="col-xs-12 js-cart-merchant-title">{{ _('Merchant') }}</div>
                    <div class="col-md-6 js-cart-merchant-left">
                      <span class="js-cart-merchant-name js-cart-merchant-detail">{{ shopSettings(basketShopId).companyname }}</span>
                      <span class="js-cart-merchant-phone js-cart-merchant-detail">{{ shopSettings(basketShopId).companyphone }}</span>
                      <span class="js-cart-merchant-www js-cart-merchant-detail">{{ shopSettings(basketShopId).companyurl }}</span>
                    </div>
                    <div class="col-md-6 js-cart-merchant-right">
                      <span class="js-cart-merchant-companyid js-cart-merchant-detail">{{ shopSettings(basketShopId).companyid }}</span>
                      <span class="js-cart-merchant-email js-cart-merchant-detail">{{ shopSettings(basketShopId).companyemail }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="row js-cart-totals" v-if="!basketEmpty">
            <div class="separator-column col-xs-12"></div>
            <div class="col-sm-6 js-cart-total-sums">
              <span class="js-cart-total-sum" v-if="hasVisiblePricing">{{ _('Total') }}</span>
            </div>
            <div class="col-sm-6 js-cart-total-sums" style="text-align: right">
              <span class="js-cart-total-sum" v-if="hasVisiblePricing">{{ $filters.currency(basketTotal, basketCurrency) }}</span>
            </div>
          </div>
          <div class="row well well-sm" v-for="payment in payments" v-if="!basketEmpty">
            <div class="col-sm-7" style="padding-left: 5px">
              {{ getPaymentTitle(payment.type) }}
            </div>
            <div class="col-sm-5" style="text-align: right">
              {{ $filters.currency(payment.amount, basketCurrency) }}
            </div>
          </div>
          <div class="row js-cart-totals" v-if="!basketEmpty">
            <div class="col-sm-6 js-cart-total-sums">
              <span class="js-cart-due-sum-title" v-if="hasVisiblePricing">{{ _('Due') }}</span>
            </div>
            <div class="col-sm-6 js-cart-total-sums" style="text-align: right">
              <span class="js-cart-due-sum" v-if="hasVisiblePricing">{{ $filters.currency(due, basketCurrency) }}</span>
            </div>
            <div class="col-sm-6 js-cart-total-sums" v-if="returnable > 0">
              <span class="js-cart-return-sum" v-if="hasVisiblePricing">{{ _('Return') }}</span>
            </div>
            <div class="col-sm-6 js-cart-total-sums" style="text-align: right" v-if="returnable > 0">
              <span class="js-cart-return-sum" v-if="hasVisiblePricing">{{ $filters.currency(returnable, basketCurrency) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shouldShowMobilePayQrCode" style="text-align: center">
        <img v-if="mobilePayQrCodeUrl" :src="mobilePayQrCodeUrl" />
      </div>
    </div>
    <seat-map :column="column" :theme="theme" ref="seatMap" :showButtons="false" borderRadius="20" :show="activeShow" :seatMap="seatMap" v-if="showSeatMap" v-on:confirmSelection="seatSelectionConfirmed" v-on:closeModal="closeSeatMap" v-on:seatSelected="seatSelected" v-on:seatDeselected="seatDeselected"></seat-map>
  </div>
</template>

<script>
  
import axios from 'axios'
import { CartItem, SeatMap } from '#components'
import seatmap from '~/lib/seatmap'
import basket from '~/lib/basket'
import events from '~/lib/events'
import debounce from 'lodash/debounce'
import memoize from 'lodash/memoize'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      basket: null,
      index: null,
      items: [],
      selectedPayment: false,
      selectedAmount: 0,
      approving: false,
      orderFailures: 0,
      orderSuccesses: 0,
      orderIds: {},
      terminalData: null,
      customers: [],
      customerPropagated: false,
      showSeatMap: false,
      seatMap: null,
      selectedSeats: [],
      activeShow: false,
      reloadTimeout: false,
      reloadPaymentsDebounced: null,
      mobilePayQrCodeUrl: null,
      isMobilePayIdentificationActive: false
    }
  },
  mixins: [ seatmap, basket, events ],
  props: ['className', 'component', 'components', 'column', 'columnIndex', 'user', 'clientid'],
  methods: {
    ...mapActions([
      'setActiveOrder',
      'setMobilepayToken'
    ]),
    setActiveComponent (component) {
      this.$emit('setActiveComponent', component)
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    addShowToBasket () {
      // No need to do anything
    },
    reloadWhenPossible () {
      clearTimeout(this.reloadTimeout)
      if (this.basketEmpty && !this.showSeatMap) {
        window.location.reload(true)
      } else {
        this.reloadTimeout = setTimeout(this.reloadWhenPossible, 1000)
      }
    },
    memoizeDebounce: function(func, wait = 0, options = {}) {
      var mem = memoize(function() {
        return debounce(func, wait, options)
      }, options.resolver)
      return function() { mem.apply(this, arguments).apply(this, arguments) }
    },
    async loadMobilePayQrCodeUrl () {
      let response 
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/pos/' + this.pos + '.json?mobilepayqrcode=true&apikey=' + this.apiKey)
      } catch (e) {
        console.log(e)
        return
      }
      return response.data
    }
  },
  computed: {
    ...mapGetters([
      'mobilepayToken'
    ]),
    payments: {
      get () {
        return this.$store.state.payments[this.shopId + '-' + this.index] ? this.$store.state.payments[this.shopId + '-' + this.index] : []
      },
      set (newValue) {
        this.$store.dispatch('setPayments', { shopId: this.shopId, index: this.index, payments: newValue })
      }
    },
    theme () {
      return this.data.theme
    },
    settings () {
      return this.shopSettings(this.shopId)
    },
    profileImage () {
      return this.component.file_id ? this.baseDomain + this.shopId + '/largefiles/' + this.component.file_id + '.' + this.component.file_ext : false
    },
    hasBackground () {
      return this.component.sharedFile && this.component.sharedFile[0] && this.component.sharedFile[0].id
    },
    backgroundImage () {
      return this.baseDomain + this.shopId + '/largefiles/' + this.component.sharedFile[0].id + '/' + this.component.sharedFile[0].filename
    },
    backgroundBlur () {
      return this.basketEmpty && !this.showSeatMap ? 0 : 20
    },
    backgroundClass () {
      return 'client-background'
    },
    logoClass () {
      return 'row' + (this.basketEmpty ? ' row-fullscreen' : '')
    },
    blurClass () {
      return 'client-background client-blur ' + (this.backgroundBlur ? 'client-blur-visible' : '')
    },
    shouldShowMobilePayQrCode () {
      return this.data.mobilepayqrcode === '1' && !this.mobilepayToken && this.isMobilePayIdentificationActive
    },
    customer: {
      get () {
        return this.allCustomers[this.data.index]
      },
      set () {
      }
    }
  },
  components: {
    CartItem,
    SeatMap
  },
  updated () {
    if (this.index !== this.data.index) {
      this.initBasket()
    }
  },
  watch: {
    myBasketItems (newValue) {
      if (this.mobilepayToken && (!newValue || !newValue.length)) {
        this.setMobilepayToken(null)
      }
    },
    async isMobilePayIdentificationActive (newVal) {
      if (newVal && !this.mobilePayQrCodeUrl) {
        this.mobilePayQrCodeUrl = await this.loadMobilePayQrCodeUrl()
      }
    }
  },
  async mounted () {
    this.reloadPaymentsDebounced = this.memoizeDebounce(this.reloadPayments, 200)
    this.initBasket(false, () => {
      this.reloadPayments(this.shopId + '-' + this.index)
    })
    if (this.shouldShowMobilePayQrCode) {
      this.mobilePayQrCodeUrl = await this.loadMobilePayQrCodeUrl()
    }
    if(!this.events) {
      let events = {}
      events['approve'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.approving = true
        }
      }
      events['setCustomer'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.customerPropagated = true
          this.customer = message.data
          this.customerPropagated = false
        }
      }
      events['clearCustomer'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.customerPropagated = true
          this.customer = null
          this.customerPropagated = false
        }
      }
      events['cancelapprove'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.approving = false
        }
      }
      events['pospaymentUpdate'] = (data) => {
        if (data && data.data && data.data.basketidentifier && data.data.basketidentifier === this.basketIds[this.shopId + '-' + this.index]) {
          this.reloadPaymentsDebounced(this.shopId + '-' + this.index)
        }
      }
      events['reloadWhenPossible'] = (message) => {
        this.reloadWhenPossible()
      }
      events['modifyOrder'] = async (message) => {
        const order = message.order
        if (!order) {
          this.setActiveOrder(null)
          this.closeAdminBasket()
          return
        }
        this.setActiveOrder(order)
        /*
        if (order.customer_id) {
          this.selectedCustomer = await this.loadCustomer(order.customer_id)
        } else {
          this.selectedCustomer = null
        }
        if (order.billingcustomer_id) {
          this.selectedBillingcustomer = await this.loadBillingCustomer(order.billingcustomer_id)
        } else {
          this.selectedBillingcustomer = null
        }
        */
        this.initAdminBasket(order.identifier)
      }
      events['startMobilepayIdentification'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.isMobilePayIdentificationActive = true
        }
      }
      events['stopMobilepayIdentification'] = (message) => {
        if (message.pos === this.pos && message.index === this.index) {
          this.isMobilePayIdentificationActive = false
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>

<style scoped>
.dark .panel {
  background-color: #222222;
}
.dark .panel-default {
  border-color: #111111;
}
.dark .separator-column {
  border-top-color: #111111;
}
.dark .js-cart-merchant-detail {
  color: #98ADB8 ! important;
}
.dark .js-cart-total-sum, .dark .js-cart-due-sum, .dark .js-cart-due-sum-title {
  color: #ffffff ! important;
}
.dark .well {
  margin-top: 10px;
  background-color: #1F1F1F;
  box-shadow: inset 0 2px 0 #111111;
  border-color: #333333;
  color: #98ADB8;
}
.js-cart-merchant-row {
  padding-top: 10px;
}
</style>